define(['jquery', 'app/global', 'app/tools', 'jquery.cookie'], function ($, global, tools) {
  // Cookie RODO V4
  return function() {

    window.addEventListener('load', function () {

      // START RODO V4
      // Flyfooter RODO z dwoma ekranami, https://redmine.k2.pl/issues/110110

      var cookiesRodoV4 = {
        acceptFull: {
          name: '3_RODO_FULL',
          options: {
            expires: 365,
            path: '/',
          },
        },
        reject: {
          name: '5_RODO_REJECT',
          options: {
            expires: 1 / 8,
            path: '/',
          },
        },
        settings: {
          name: '4_RODO_SETTINGS',
          options: {
            expires: 365,
            path: '/',
          },
        },
        acceptPart: {
          name: '1_RODO_PART',
          options: {
            expires: 365,
            path: '/',
          },
        },
        postpone: {
          name: '2_RODO_POSTPONE',
          options: {
            expires: 1 / 8,
            path: '/',
          },
        },
        UID: {
          name: 'PKOBP_UID',
          options: {
            expires: 365 * 2,
            path: '/',
          },
        },
      };

      var $rodoV4containerFirst = document.querySelector('#pko-cookie-rodo-first');
      var $rodoV4containerSecond = document.querySelector('#pko-cookie-rodo-second');

      function getCookie(name) {
        var v = document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)');
        return v ? v[2] : null;
      }

      function setCookie(name, value, days) {
        var d = new Date;
        d.setTime(d.getTime() + 24 * 60 * 60 * 1000 * days);
        document.cookie = name + '=' + value + ';path=/;expires=' + d.toGMTString();
      }

      function deleteCookie(name) {
        setCookie(name, '', -1);
      }

      function rodoV4($firstLayer, $secondLayer) {
        var _self = this;

        this.$containerFirst = $firstLayer;
        this.$containerSecond = $secondLayer;

        this.topSelector = '.cookie-rodo__content-wrapper';
        this.bottomSelector = '.cookie-rodo__button-wrapper';

        this.isAggressive = this.$containerFirst.classList.contains('cookie-rodo--center');

        this.init = function () {
          this.setPkoBpUID();
          this.showModal(this.$containerFirst);
          this.showOverlay();
          this.setEvents();
        };

        this.showModal = function ($elem) {
          $elem.style.display = 'block';

          this.setRodoCenteredModalHeight($elem);
        };

        this.closeModal = function ($elem) {
          $elem.style.display = 'none';
        };

        this.getOverlay = function() {
          if(this.isAggressive) {
            return document.querySelector('.pko-cookie-rodo-overlay');
          }
        };

        this.showOverlay = function() {
          if(this.isAggressive && !this.getOverlay()) {
            var $overlay = document.createElement('div');
            $overlay.classList.add('pko-cookie-rodo-overlay');
            document.body.appendChild($overlay);
          }
        };

        this.hideOverlay = function() {
          if(this.isAggressive) {
            var $overlay = this.getOverlay();

            if($overlay) {
              document.body.removeChild($overlay);
            }
          }
        };

        this.generatePkoBpUID = function () {
          var randomNumber = Math.floor((Math.random() * (Math.pow(10, 10))) + 1);
          var unixTimestamp = (new Date().getTime() / 1000).toFixed(0);
          var UID = randomNumber + '.' + unixTimestamp;

          return UID;
        };

        this.setPkoBpUID = function () {
          if (!getCookie(cookiesRodoV4.UID.name)) {
            if(document.domain !== 'www.pkobh.pl' && document.domain !== 'pkobh.pl') {
              setCookie(cookiesRodoV4.UID.name, this.generatePkoBpUID(), cookiesRodoV4.UID.options.expires);
            }
          }
        };

        this.setRodoCenteredModalHeight = function ($elem) {
          if (this.isAggressive && window.innerWidth > 768) {
            if (Array.isArray($elem)) {
              for( var i = 0, eLen = $elem.length; i < eLen; i++) {
                var item = $elem[i];
                var newHeight = item.querySelector(this.topSelector).offsetHeight;
                newHeight += item.querySelector(this.bottomSelector).offsetHeight;

                item.style.height = newHeight + 'px';
              }
              return;
            }

            var newHeight = $elem.querySelector(this.topSelector).offsetHeight;
            newHeight += $elem.querySelector(this.bottomSelector).offsetHeight;

            $elem.style.height = newHeight + 'px';
          } else {
            if (Array.isArray($elem)) {
              for( var i = 0, eLen = $elem.length; i < eLen; i++) {
                item.style.height = null;
              }
              return;
            }

            $elem.style.height = null;
          }
        }

        this.setEvents = function () {
          window.addEventListener('resize', this.setRodoCenteredModalHeight.bind(this, [
            this.$containerFirst,
            this.$containerSecond
          ]));

          document.querySelector('#pko-cookie-rodo-first-accept').addEventListener('click', function (event) {
            event.preventDefault();

            _self.setPkoBpUID();

            deleteCookie(cookiesRodoV4.settings.name);
            setCookie(cookiesRodoV4.acceptFull.name, true, cookiesRodoV4.acceptFull.options.expires);

            _self.closeModal(_self.$containerFirst);
            _self.hideOverlay();
          });

          document.querySelector('#pko-cookie-rodo-first-reject').addEventListener('click', function (event) {
            event.preventDefault();

            _self.setPkoBpUID();

            deleteCookie(cookiesRodoV4.settings.name);
            setCookie(cookiesRodoV4.reject.name, true, cookiesRodoV4.reject.options.expires);

            _self.closeModal(_self.$containerFirst);
            _self.hideOverlay();
          });

          document.querySelector('#pko-cookie-rodo-first-settings').addEventListener('click', function (event) {
            event.preventDefault();

            _self.setPkoBpUID();

            setCookie(cookiesRodoV4.settings.name, true, cookiesRodoV4.settings.options.expires);

            _self.showModal(_self.$containerSecond);
            _self.closeModal(_self.$containerFirst);
          });

          document.querySelector('#pko-cookie-rodo-second-accept').addEventListener('click', function (event) {
            event.preventDefault();

            _self.setPkoBpUID();

            deleteCookie(cookiesRodoV4.settings.name);
            setCookie(cookiesRodoV4.acceptPart.name, true, cookiesRodoV4.acceptPart.options.expires);

            _self.closeModal(_self.$containerSecond);
            _self.hideOverlay();
          });

          document.querySelector('#pko-cookie-rodo-second-postpone').addEventListener('click', function (event) {
            event.preventDefault();

            _self.setPkoBpUID();

            deleteCookie(cookiesRodoV4.settings.name);
            setCookie(cookiesRodoV4.postpone.name, true, cookiesRodoV4.postpone.options.expires);

            _self.closeModal(_self.$containerSecond);
            _self.hideOverlay();
          });
        };
      }

      if ($rodoV4containerFirst && $rodoV4containerSecond
        && !getCookie(cookiesRodoV4.acceptFull.name)
        && !getCookie(cookiesRodoV4.reject.name)
        && !getCookie(cookiesRodoV4.acceptPart.name)
        && !getCookie(cookiesRodoV4.postpone.name)
      ) {
        var rodoV4 = new rodoV4($rodoV4containerFirst, $rodoV4containerSecond);
        rodoV4.init();
      }

      // END RODO V4

    });

  };
});



// WEBPACK FOOTER //
// ./_front/_inteligo/js/shared/cookie-policy-v4.js